import React, { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';
import { FiAlertCircle } from 'react-icons/fi';

const ChangeConfirmation = ({ show, onClose, info, callBk, method = 'PUT' }) => {
    const { setResp } = useContextInfo();
    const { data, endpoint, head, body } = info;
    const [send, setSend] = useState(false);
    const acepOk = async () => {
        if (send) return;
        setSend(true);
        const res = await fetchConToken(`${endpoint}`, { ...data }, method);
        setResp(res);
        callBk();
        setSend(false);
        onClose();
    };
    return (
        <Modal show={show} onHide={onClose} size="sm">
            <Modal.Header onHide={onClose} closeButton>
                <h4 className="modal-title">{head}</h4>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center">
                    <FiAlertCircle className="fs-1 inline-flex" />
                    <h3 className="mb-5 fs-4 font-normal ">{body}</h3>

                    {send ? (
                        <Button color="primary" disabled>
                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                            Procesando...
                        </Button>
                    ) : (
                        <Button type="button" onClick={acepOk} variant="warning">
                            Confirmar
                        </Button>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ChangeConfirmation;
